import { createContext, useContext, useState } from 'react';
import { TEST_CREDENTIALS } from '../config/roles';

const AuthContext = createContext(null);

const STORAGE_KEY = 'cla_auth_user';

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  const login = (email, password, requiredRole) => {
    const cred = TEST_CREDENTIALS.find(
      (c) => c.email === email.trim() && c.password === password
    );
    if (!cred) return false;
    if (requiredRole && cred.role !== requiredRole) return false;
    const userData = { email: cred.email, role: cred.role, name: cred.name };
    setUser(userData);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
    } catch {}
    return true;
  };

  const logout = () => {
    setUser(null);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
